import React from 'react';

import CountryInfo from '../CountryInfo';

const STIMULUS_SECTION = {
    title: 'Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">
                Tax rebates & Deferral
            </p>
            <p>Applies to companies earning €2m or less.</p>

            <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                Liquidity Support
            </p>
            <p>
                Companies earning €2m or less do not have to pay taxes whilst
                larger companies can ask to defer payments.
            </p>

            <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                Loan Guarantees
            </p>
            <p>State guarantee for small businesses up to €5m.</p>

            <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                Employee Rights
            </p>
            <p>
                Companies are prohibited from laying off workers for the next
                two months without &quot;justified objective reasons&quot;.
            </p>

            <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                Investment
            </p>
            <p>
                The government has promised more measures to come, including
                support for investments.
            </p>
        </div>
    ),
    links: [
        {
            title: 'Official Publication',
            url: 'https://www.gazzettaufficiale.it/eli/gu/2020/03/17/70/sg/pdf',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Italy',
    lastUpdated: 'March 27, 2020',
    introSection: (
        <p>Italy has announced a stimulus package worth $28.3 billion.</p>
    ),
    sections: [STIMULUS_SECTION],
};

const ItalyInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default ItalyInfo;
